<div class="card w-100 form-right mail-panel-card">
  <div class="back">
    <h2>
      {{
        replyMode
          ? ("mail_modal.reply_title" | translate)
          : ("mail_modal.title" | translate)
      }}
    </h2>
    <i class="icon-cross2" (click)="close()"></i>
  </div>

  <div class="card-body mail-panel-body">
    <!-- Destinatario -->
    <div class="form-section">
      <div class="mb-3">
        <label class="form-label">{{ "mail_modal.to" | translate }}</label>
        <input
          type="text"
          class="form-control"
          [value]="
            clientName ? clientName + ' (' + clientEmail + ')' : clientEmail
          "
          disabled
        />
      </div>
    </div>

    <!-- Hilos IMAP -->
    <div
      class="form-section"
      *ngIf="
        !replyMode &&
        (threadLoading || (threadSearchDone && threadMessages.length > 0))
      "
    >
      <div class="mb-3">
        <!-- Header colapsable -->
        <div
          class="thread-dropdown-header"
          (click)="threadListOpen = !threadListOpen"
        >
          <div class="thread-dropdown-left">
            <i class="icon-history"></i>
            <span>{{ "mail_modal.threads" | translate }}</span>
            <span
              *ngIf="threadSearchDone && threadMessages.length > 0"
              class="badge bg-primary thread-badge"
              >{{ threadMessages.length }}</span
            >
            <div
              class="spinner-border spinner-border-sm text-primary ms-2"
              role="status"
              *ngIf="threadLoading"
            ></div>
          </div>
          <i
            [class]="threadListOpen ? 'icon-chevron-up' : 'icon-chevron-down'"
            class="thread-dropdown-arrow"
            *ngIf="!threadLoading && threadMessages.length > 0"
          ></i>
        </div>

        <!-- Lista colapsable -->
        <div
          class="thread-list"
          *ngIf="threadListOpen && !threadLoading && threadMessages.length > 0"
        >
          <div class="thread-item" *ngFor="let msg of threadMessages">
            <div class="thread-item-header">
              <div class="thread-item-left">
                <span class="thread-sender">{{
                  getFromDisplay(msg.from)
                }}</span>
                <span class="thread-subject">{{
                  msg.subject || "(Sin asunto)"
                }}</span>
              </div>
              <div class="thread-item-right">
                <span class="badge text-draft" *ngIf="msg.has_attachments"
                  ><i class="icon-paperclip"></i
                ></span>
                <span class="badge bg-soft-sent" *ngIf="msg.folder === 'sent'"
                  ><i class="icon-paper-plane"></i
                ></span>
                <span class="thread-date">{{ formatDate(msg.date) }}</span>
                <button
                  class="btn-reply"
                  type="button"
                  (click)="loadThreadAndReply(msg, $event)"
                  [title]="'mail_modal.reply' | translate"
                >
                  <i class="icon-reply"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading hilo completo -->
    <div class="form-section" *ngIf="fullThreadLoading">
      <div class="thread-loading">
        <div
          class="spinner-border spinner-border-sm text-primary"
          role="status"
        ></div>
        <span class="text-muted ms-2">{{
          "mail_modal.loading_thread" | translate
        }}</span>
      </div>
    </div>

    <!-- Reply mode: hilo completo -->
    <div class="form-section" *ngIf="replyMode && fullThread.length > 0">
      <div class="mb-3">
        <div class="reply-header">
          <button
            class="btn btn-sm btn-outline-secondary"
            type="button"
            (click)="exitReplyMode()"
          >
            <i class="icon-arrow-left"></i>
            {{ "mail_modal.new_mail" | translate }}
          </button>
          <span class="text-muted reply-subject">{{ replySubject }}</span>
        </div>
        <div class="full-thread-list">
          <div
            class="full-thread-msg"
            *ngFor="let tmsg of fullThread"
            [class.thread-sent]="tmsg.folder === 'sent'"
            [class.thread-received]="tmsg.folder === 'inbox'"
          >
            <div class="full-thread-msg-header">
              <div class="sender-avatar">
                {{ getFromDisplay(tmsg.from).charAt(0).toUpperCase() }}
              </div>
              <div class="full-thread-msg-info">
                <span class="thread-sender">{{
                  getFromDisplay(tmsg.from)
                }}</span>
                <span class="thread-date">{{ formatDate(tmsg.date) }}</span>
              </div>
              <span class="badge bg-soft-sent" *ngIf="tmsg.folder === 'sent'"
                ><i class="icon-paper-plane"></i
              ></span>
            </div>
            <div
              class="full-thread-msg-body"
              [innerHTML]="tmsg.body_html || tmsg.body_text || ''"
            ></div>
          </div>
        </div>
      </div>
    </div>

    <!-- Selector de plantilla (solo en modo nuevo) -->
    <div class="form-section" *ngIf="!replyMode">
      <div class="mb-3">
        <label class="form-label">{{
          "mail_modal.select_template" | translate
        }}</label>
        <ng-select
          [items]="mailTemplates"
          bindLabel="name"
          [(ngModel)]="selectedTemplate"
          (change)="onTemplateSelected()"
          [placeholder]="'mail_modal.select_placeholder' | translate"
          [searchable]="true"
          [clearable]="true"
          [notFoundText]="'tables.no_results' | translate"
        >
        </ng-select>
      </div>
    </div>

    <!-- Subject (disabled en reply) -->
    <div class="form-section">
      <div class="mb-3">
        <label class="form-label">{{
          "settings.mail.templates.subject" | translate
        }}</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="mailEditSubject"
          [placeholder]="'mail_modal.no_subject' | translate"
          [disabled]="replyMode"
        />
      </div>
    </div>

    <!-- Body editable con barra de formato -->
    <div class="form-section">
      <div class="mb-3">
        <label class="form-label">{{
          "settings.mail.templates.body" | translate
        }}</label>
        <div class="editor-toolbar">
          <button
            type="button"
            class="toolbar-btn"
            (click)="execCommand('bold')"
            title="Bold"
          >
            <b>B</b>
          </button>
          <button
            type="button"
            class="toolbar-btn"
            (click)="execCommand('italic')"
            title="Italic"
          >
            <i>I</i>
          </button>
          <button
            type="button"
            class="toolbar-btn"
            (click)="execCommand('underline')"
            title="Underline"
          >
            <u>U</u>
          </button>
          <span class="toolbar-separator"></span>
          <button
            type="button"
            class="toolbar-btn"
            (click)="execCommand('justifyLeft')"
            title="Align Left"
          >
            <i class="icon-align-left"></i>
          </button>
          <button
            type="button"
            class="toolbar-btn"
            (click)="execCommand('justifyCenter')"
            title="Center"
          >
            <i class="icon-align-center"></i>
          </button>
          <button
            type="button"
            class="toolbar-btn"
            (click)="execCommand('justifyRight')"
            title="Align Right"
          >
            <i class="icon-align-right"></i>
          </button>
          <span class="toolbar-separator"></span>
          <button
            type="button"
            class="toolbar-btn"
            (click)="execCommand('insertUnorderedList')"
            title="Bullet List"
          >
            <i class="icon-list"></i>
          </button>
          <button
            type="button"
            class="toolbar-btn"
            (click)="execCommand('insertOrderedList')"
            title="Numbered List"
          >
            <i class="icon-list-numbered"></i>
          </button>
        </div>
        <div
          #bodyEditor
          class="editor-body"
          contenteditable="true"
          (input)="onBodyInput()"
          [attr.data-placeholder]="
            (replyMode ? 'mail_modal.reply_placeholder' : 'mail_modal.no_body')
              | translate
          "
        ></div>
      </div>
    </div>

    <!-- Adjuntos -->
    <div class="form-section">
      <div class="mb-3">
        <label class="form-label">{{
          "mail_modal.attachments" | translate
        }}</label>
        <div
          class="drop-zone"
          (drop)="onDrop($event)"
          (dragover)="onDragOver($event)"
          (dragleave)="onDragLeave($event)"
          (click)="fileInput.click()"
        >
          {{ "forms.labels.draganddrop" | translate }}
          <input
            #fileInput
            type="file"
            multiple
            class="input-file-hidden"
            (change)="onFilesSelected($event)"
            hidden
          />
        </div>
        <ul class="attachment-list" *ngIf="mailAttachments.length > 0">
          <li *ngFor="let file of mailAttachments; let i = index">
            <div class="listFiles">
              <div class="div-thumbnail">
                <img
                  class="thumbnail"
                  [src]="getThumbnailSrc(file)"
                  alt="Thumbnail"
                />
                {{ file.name }}
                <small class="text-muted ms-1"
                  >({{ formatFileSize(file.size) }})</small
                >
              </div>
              <span class="trash clickable" (click)="removeAttachment(i)">
                <i class="icon-trash"></i>
              </span>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <!-- Botones debajo de adjuntos 
    <div class="btn-send">
      <button class="btn btn-outline-secondary" type="button" (click)="close()">
        {{ "buttons.cancel" | translate }}
      </button>
      <button class="btn btn-primary btn-primary-form" type="button"
        [disabled]="!canSend()" (click)="sendMail()">
        <i [class]="replyMode ? 'icon-reply' : 'icon-envelope'"></i>
        {{ (replyMode ? "mail_modal.reply" : "buttons.send") | translate }}
      </button>
    </div>-->
    <div class="d-flex justify-content-end" style="gap: 10px;">
      
      <button
        class="btn btn-primary btn-primary-form"
        type="button"
        [disabled]="!canSend()"
        (click)="sendMail()"
      >
        <i [class]="replyMode ? 'icon-reply' : 'icon-envelope'"></i>
        {{ (replyMode ? "mail_modal.reply" : "buttons.send") | translate }}
      </button>
      <button class="btn btn-outline-secondary" type="button" (click)="close()">
        {{ "buttons.cancel" | translate }}
      </button>
    </div>
  </div>
</div>
